export default __webpack_public_path__ + "static/deer-hill-text-inline-d197f829ba1a08c6e9aa81973909e2e3.svg";